import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { UserModel } from '../models/user/userModel';
import { UserChangePasswordModel } from '../models/user/userChangePasswordModel';

class LoginService {

  // constructor() {
  //   axios.defaults.baseURL = `${Constants.apiUrl}`;
  // }

  createUser(user: UserModel) {
    return axios({
      url: `${Constants.apiUrl}/login/create`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  validateAndActivate(confirmCode: string) {
    return axios({
      url: `${Constants.apiUrl}/login/validateAndActivate`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(confirmCode)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  validateConfirmCode(confirmCode: string) {
    return axios({
      url: `${Constants.apiUrl}/login/ValidateConfirmCode`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(confirmCode)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  forgotPassword(email: string) {
    return axios({
      url: `${Constants.apiUrl}/login/forgotPassword/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(email)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  newPassword(user: UserChangePasswordModel) {
    return axios({
      url: `${Constants.apiUrl}/login/newPassword/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default LoginService;